/**
 * GuestTemplateTracker — mounted once in App.tsx. On guest-facing template routes (/i/:slug,
 * /demo/<name>) it installs the shared template interaction tracking (share, directions, music,
 * scroll milestones) and sends the demo page_view. Real invitations send their page_view from
 * PublicInvitation once the invitation (template / occasion / id) has loaded.
 * See infrastructure/lib/template-analytics.ts.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  DEMO_TEMPLATE_IDS,
  clearTemplateContext,
  guestTemplateRoute,
  installGuestTemplateTracking,
  startTemplateView,
} from '@/src/infrastructure/lib/template-analytics';

export function GuestTemplateTracker(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    const route = guestTemplateRoute(pathname);
    if (!route) {
      clearTemplateContext(pathname);
      return;
    }
    if (route.surface === 'demo' && route.demo) {
      startTemplateView(pathname, {
        surface: 'demo',
        templateId: DEMO_TEMPLATE_IDS[route.demo] ?? `demo-${route.demo}`,
      });
    }
    return installGuestTemplateTracking();
  }, [pathname]);

  return null;
}
